import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  BenchmarkStatisticsPerMonth,
  MonthlyStatistics,
} from '@tassomutuo-backoffice/types';
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { format, parse } from 'date-fns';
import { it } from 'date-fns/locale';
import formatMoney from '../../../utils/formatMoney';

interface IProps {
  statisticsPerMonth: MonthlyStatistics;
  benchmarkStatisticsPerMonth?: BenchmarkStatisticsPerMonth;
  isPrinting?: boolean;
  reverse?: boolean;
}
const DashboardRevenuePerLeadChart = ({
  statisticsPerMonth,
  benchmarkStatisticsPerMonth,
  isPrinting,
  reverse = true,
}: IProps) => {
  const chartData = Object.entries(statisticsPerMonth).map(([month, stats]) => {
    const revenuePerLeadBench = benchmarkStatisticsPerMonth?.find(
      (m) => m.month === month
    )?.statistics.revenuePerLead;

    return {
      month,
      revenuePerLead: stats.revenuePerLead,
      revenuePerLeadBench: revenuePerLeadBench,
    };
  });

  if (reverse) {
    chartData.reverse();
  }

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        padding: 4,
        mt: 6,
        borderRadius: '16px',
        border: '1px solid gainsboro',
      }}
    >
      <Typography variant="h4" mb={1} fontWeight="bold">
        Revenue Per Lead
      </Typography>
      <Typography variant="h6" mb={4}>
        Stima di fatturato per ciascun lead
      </Typography>
      <Box
        sx={{
          width: '100%',
          height: 400,
          p: 2,
          minWidth: isPrinting ? 1100 : undefined,
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <Line
              type="monotone"
              dataKey="revenuePerLead"
              stroke="rgba(59, 130, 246, 1)"
              strokeWidth={4}
            />
            <Line
              type="monotone"
              dataKey="revenuePerLeadBench"
              strokeWidth={4}
              stroke="rgba(16, 60, 85, 1)"
            />
            <CartesianGrid
              stroke="#ccc"
              strokeDasharray="3 3"
              vertical={false}
            />
            <XAxis
              dataKey="month"
              tickFormatter={(month) => {
                const date = parse(month, 'MMMM yyyy', new Date(), {
                  locale: it,
                });
                return format(date, 'MMM yy', { locale: it });
              }}
            />
            <YAxis domain={[0, (dataMax: number) => Math.ceil(dataMax * 1.1)]} />
            <Tooltip
              //labelFormatter={(label) => `Mese: ${label}`}
              formatter={(value, dataType) => {
                const isBench = dataType === 'revenuePerLeadBench';
                const formattedValue = typeof value === 'number' ? formatMoney(value) : value;
                return [formattedValue, isBench ? 'Benchmark' : 'Revenue/Lead'];
              }}
            />
            <Legend
              formatter={(value) => {
                switch (value) {
                  case 'revenuePerLead':
                    return 'Revenue/Lead';
                  case 'revenuePerLeadBench':
                    return 'Revenue/Lead Benchmark';
                  default:
                    return value;
                }
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default DashboardRevenuePerLeadChart;
